
export default {
  name: 'WidgetNuxtNode',
  functional: true,
  render(h, ctx) {
    let { widgetType, widgetApi, nodeId, id, file, dataInject } = ctx.props;
    let values = file.nodes[nodeId];

    // 无事件无数据绑定无延迟加载无数据统计的组件
    if (values.static?.event && values.static?.i18n) {
      if (!values.isLazyLoad && !values.trackBehavior?.isReport) {
        let type = values.type;
        let needText = false;
        let isStatic = false;
        let customClass = '';
        let children;
        let obj = { attrs: { id } };
        if (type === 'WidgetRoundedRect' || type === 'WidgetList') {
          isStatic = true;
          children = ctx.children;
        } else if (type === 'WidgetText') {
          isStatic = true;
          customClass = 'widget-text';
          needText = true;
        } else if (type === 'WidgetRichText') {
          isStatic = true;
          needText = true;
          customClass = 'widget-rich-text';
        } else if (type === 'WidgetSvg') {
          isStatic = true;
          needText = true;
          customClass = 'widget-svg';
        }
        if (isStatic) {
          let cls = values.class;
          cls = cls?.normal ?? cls;
          if (typeof cls === 'string') {
            cls = [cls];
          } else if (!Array.isArray(cls)) {
            cls = [];
          }
          cls = cls.concat(ctx.data.class);
          if (customClass) {
            cls.push(customClass);
          }
          if (values.sysClass) {
            cls.push(values.sysClass);
          }

          obj.class = cls;
          if (needText) {
            let text = values.text;
            if (text && typeof text !== 'string') {
              text = text?.normal ?? '';
            }
            if (type === 'WidgetText') {
              children = text;
            } else {
              obj.domProps = { innerHTML: text };
            }
          }
          return h('div', obj, children);
        }
      }
    }

    let data = {
      props: {
        nodeId,
        id,
        file,
        widgetApi,
        values: {
          ...values,
          dataInject,
        },
        $bus: widgetApi.$bus,
      },
      class: ctx.data.class,
      attrs: { id },
      slot: values.slot || 'default',
    };
    if (id !== nodeId) {
      data.attrs['node-id'] = nodeId;
    }
    return h(widgetType, data, ctx.children);
  },
};
